// inputs.js
import { validateRequired,validateLength, validateNonZeroInteger,validateNotNull }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Codigo",
    name: "pcia_codigo",
    type: "int",
    placeholder: "Ingrese el codigo",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateNonZeroInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Descripcion",
    name: "pcia_descripcion",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Abreviatura",
    name: "pcia_abrev",
    type: "int",
    placeholder: "Ingrese la Abreviatura",
    validation: (value, form) => {
      // Validación requerida
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 5 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Visibilidad",
    name: "pcia_show_web",
    type: "select",
    options: [
      { value: 0, label: "Visible" },
      { value: 1, label: "Oculto" }
    ],
    validation: (value, form) => {
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }
      return null;
    }
  }
];

export default Inputs;
